import { useEffect, useRef, useState } from 'react';
import { animate, useInView, useReducedMotion } from 'framer-motion';

function parseValue(raw) {
  const match = String(raw).trim().match(/^([\d.]+)(.*)$/);
  if (!match) {
    return { target: 0, decimals: 0, trailing: String(raw) };
  }
  const numStr = match[1];
  const decimals = numStr.includes('.') ? numStr.split('.')[1].length : 0;
  return {
    target: Number(numStr),
    decimals,
    trailing: match[2] || '',
  };
}

function formatNumber(n, decimals) {
  if (decimals > 0) return n.toFixed(decimals);
  return String(Math.round(n));
}

export default function CountUpValue({
  value,
  duration = 1.55,
  className,
  once = true,
  amount = 0.45,
  /** When false, counting waits (e.g. until a modal closes). */
  active = true,
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once, amount });
  const reduceMotion = useReducedMotion();
  const { target, decimals, trailing } = parseValue(value);
  const [display, setDisplay] = useState(() => formatNumber(0, decimals));
  const started = useRef(false);

  useEffect(() => {
    if (!active || !inView || started.current) return;
    started.current = true;

    if (reduceMotion) {
      setDisplay(formatNumber(target, decimals));
      return undefined;
    }

    const controls = animate(0, target, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (latest) => setDisplay(formatNumber(latest, decimals)),
    });

    return () => controls.stop();
  }, [active, inView, reduceMotion, target, decimals, duration]);

  return (
    <span ref={ref} className={className}>
      {display}
      {trailing}
    </span>
  );
}
